import "./styles.css";

export const BarSpinner = () => {
  return (
    <div className="bar-spinner">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};
